// extracted by mini-css-extract-plugin
module.exports = {"switchRoomsImage":"SwitchRooms_switchRoomsImage__1Q43D","closeDiv":"SwitchRooms_closeDiv__1CpIb"};